// テキスト/名称系のユーティリティ（データテーブルからの名称取得など）
import itemData from "../data/item.json";
import moveData from "../data/move.json";
import { getMegaStoneNameByItemId } from "../lib/mega-stone";

interface Item {
  id: number;
  name_ja: string;
  name_en: string;
  picture_url: string;
}

interface MoveData {
  id: number;
  name_ja: string;
  name_en: string;
  type: number;
  accuracy: number;
  power: number;
  damage_class_number: number;
}

const itemList = itemData as Item[];
const moveList = moveData as MoveData[];

// ID検索を高速化するためにMapへ展開
const itemNameMap = new Map<number, string>();
itemList.forEach((item) => {
  itemNameMap.set(item.id, item.name_ja);
});

// 技ID→日本語名の参照テーブル
const moveNameMap = new Map<number, string>();
moveList.forEach((move) => {
  moveNameMap.set(move.id, move.name_ja);
});

export const getItemNameById = (itemId: number): string | undefined =>
  itemNameMap.get(itemId) ?? getMegaStoneNameByItemId(itemId);

export const getMoveNameById = (moveId: number): string | undefined => moveNameMap.get(moveId);
